import React, { FC } from 'react';
import classNames from 'classnames';

import { TRate } from '@sv-support-sdk/shared-types/src/common/chats';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';
import Paragraph from '@sv-support-sdk/ui-components/src/components/Typography/Paragraph';

// @ts-ignore
import smile1 from '../../../assets/images/smile-1.png';
// @ts-ignore
import smile2 from '../../../assets/images/smile-2.png';
// @ts-ignore
import smile3 from '../../../assets/images/smile-3.png';
// @ts-ignore
import smile4 from '../../../assets/images/smile-4.png';
// @ts-ignore
import smile5 from '../../../assets/images/smile-5.png';

import css from './style.module.scss';

import { $l } from '../../../locales';
import useMobileDetect from '../../../hooks/useMobileDetect';

interface IProps {
  rate?: TRate;
  type?: 'customerEffort';
  gap?: '4';
  size?: 'lg';
  viewOnly?: boolean;
  selectRate?: (value: number) => void;
}

const Rating: FC<IProps> = ({ rate, type, gap, size, viewOnly, selectRate }) => {
  const isMobile = useMobileDetect();

  const rateOptions = [
    { value: 1, src: smile1, alt: 'Rating 1', text: $l('CHAT.RATING_1') },
    { value: 2, src: smile2, alt: 'Rating 2', text: $l('CHAT.RATING_2') },
    { value: 3, src: smile3, alt: 'Rating 3', text: $l('CHAT.RATING_3') },
    { value: 4, src: smile4, alt: 'Rating 4', text: $l('CHAT.RATING_4') },
    { value: 5, src: smile5, alt: 'Rating 5', text: $l('CHAT.RATING_5') },
  ];

  if (rate === 0) {
    return null;
  }

  const rateOption = rateOptions.find(option => option.value === rate);

  if (viewOnly && rateOption) {
    return (
      <List align="center" gap={gap}>
        <div
          className={classNames(css.rating__button, {
            [css[`rating__button_size_${size}`]]: size,
            [css.isChecked]: true,
          })}
        >
          <img
            className={classNames(css.rating__img, {
              [css[`rating__img_size_${size}`]]: size,
            })}
            src={rateOption.src}
            alt={rateOption.alt}
          />
        </div>
        <div
          className={classNames(css.rating__text, {
            [css[`rating__text_type_${type}`]]: type,
          })}
        >
          {rateOption.text}
        </div>
      </List>
    );
  }

  return (
    <List gap="8">
      <List direction="row" align="center" gap={isMobile ? "16" : "24"}>
        {rateOptions.map(rateOption => (
          <List key={rateOption.value} align="center" gap={gap}>
            <button
              className={classNames(css.rating__button, {
                [css[`rating__button_size_${size}`]]: size,
              })}
              onClick={() => selectRate?.(rateOption.value)}
            >
              <img
                className={classNames(css.rating__img, {
                  [css[`rating__img_size_${size}`]]: size,
                })}
                src={rateOption.src}
                alt={rateOption.alt}
              />
            </button>
          </List>
        ))}
      </List>
      <List direction="row" justify="space-between">
        <Paragraph letterSpacing="0_17">
          {$l('CHAT.RATING_1')}
        </Paragraph>
        <Paragraph letterSpacing="0_17">
          {$l('CHAT.RATING_5')}
        </Paragraph>
      </List>
    </List>
  );
};

export default Rating;
